export function getScatterDoughnutStrokeWidth(dotRadius: number) {
  return dotRadius * 0.5;
}

export function getScatterDoughnutRingRadius(dotRadius: number) {
  const strokeWidth = getScatterDoughnutStrokeWidth(dotRadius);

  return dotRadius - strokeWidth / 2;
}
